import { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "./screens/Auth/Login";
import Landing from "./screens/Landing/Landing";
import Leaderboard from "./screens/Leaderboard/Leaderboard";
import QuestionScreen from "./screens/Question/QuestionScreen";
import Rules from "./screens/Rules/Rules";
import Start from "./screens/Start/Start";

import AuthContext from "./store/Auth";

function App() {
  const authCtx = useContext(AuthContext);
  const isLoggedIn = authCtx.isLoggedIn;
  const quizs = authCtx.quizs;

  return (
    <>
      <Routes>
        <Route index element={<Landing />} />
        {/* <Route path="login" element={quizs ? <Navigate to="/question" /> : <>{isLoggedIn ? <Navigate to="/start" /> : <Login />}</>} /> */}
        <Route path="rules" element={<Rules />} />
        <Route path="leaderboard" element={<Leaderboard />} />
        {/* <Route path="question" element={quizs ? <QuestionScreen /> : <Navigate to="/start" />} />
        <Route path="start" element={isLoggedIn ? <>{quizs ? <Navigate to="/question" /> : <Start />}</> : <Navigate to="/login" />} /> */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default App;
